export enum CATEGORY {
  BIOGRAPHY = 'BIOGRAPHY',
  COMEDY = 'COMEDY',
  PITCH = 'PITCH',
  SCIENCE = 'SCIENCE',
  LECTURE = 'LECTURE'
}
